import { constants, typographyStyles } from "@newsela/angelou";

const { fontFamily, heading3Obj } = typographyStyles;
const { ui } = constants.colors;

export const SIZE_TYPES = {
  EXTRA_SMALL: "XS",
  SMALL: "SM",
  MEDIUM: "MD",
  LARGE: "LG",
  VIEW_PAGE_ACTIVITY_PICKER: "VIEW_PAGE_ACTIVITY_PICKER",
};

export const VALUE_TYPES = {
  SINGLE_VALUE: "SINGLE_VALUE",
  DOUBLE_VALUE: "DOUBLE_VALUE",
};

export const container = {
  position: "relative",
};

const SIZE_STYLE_FACTORY = {
  [SIZE_TYPES.EXTRA_SMALL]: {
    border: `1px solid ${ui.neutral[100]}`,
    iconWrapperWidth: "23px",
    iconWrapperTopPosition: "4px",
    pillPaddingRight: "6px",
    pillWidth: "70px",
    pillHeight: "24px",
    wrapperMarginTop: "3px",
    fontSize: "14px",
  },
  [SIZE_TYPES.SMALL]: {
    border: `1px solid ${ui.neutral[100]}`,
    iconWrapperWidth: "23px",
    iconWrapperTopPosition: "4px",
    pillPaddingRight: "6px",
    pillWidth: "96px",
    pillHeight: "24px",
    wrapperMarginTop: "3px",
    fontSize: "14px",
  },
  [SIZE_TYPES.MEDIUM]: {
    border: `1px solid ${ui.neutral[100]}`,
    iconWrapperWidth: "32px",
    pillPaddingRight: "6px",
    pillWidth: "87px",
    pillHeight: "32px",
    wrapperMarginTop: "0",
    fontSize: "20px",
  },
  [SIZE_TYPES.LARGE]: {
    border: `1px solid ${ui.neutral[100]}`,
    iconWrapperWidth: "52px",
    iconWrapperTopPosition: "0",
    pillPaddingRight: "30px",
    pillWidth: "150px",
    pillHeight: "52px",
    wrapperMarginTop: "0",
    fontSize: "24px",
  },
  [SIZE_TYPES.VIEW_PAGE_ACTIVITY_PICKER]: {
    border: `1px solid ${ui.neutral[100]}`,
    iconWrapperWidth: "45px",
    iconWrapperTopPosition: "-5px",
    pillPaddingRight: "30px",
    pillWidth: "130px",
    pillHeight: "40px",
    wrapperMarginTop: "0",
    fontSize: "24px",
  },
};

const horizontalContainerStyles = {
  display: "flex",
  flexDirection: "row",
};

const verticalContainerStyles = {
  maxWidth: "170px",
  margin: "0 auto",
  position: "absolute",
  bottom: "0",
  left: "0",
  right: "0",
  transform: "translateY(40px)",
  display: "flex",
  flexDirection: "column",
};

export const layout = (direction) => ({
  ...container,
  ...(direction === "horizontal"
    ? horizontalContainerStyles
    : verticalContainerStyles),
});

const horizontalIconWrapper = (sizeVersion) => ({
  width: SIZE_STYLE_FACTORY[sizeVersion].iconWrapperWidth,
  height: "100%",
  position: "absolute",
  left: "0",
  top: SIZE_STYLE_FACTORY[sizeVersion].iconWrapperTopPosition,
  bottom: "0",
  transform: "scale(1.2)",
  transformOrigin: "center",
});

const horizontalPill = (sizeVersion) => ({
  border: SIZE_STYLE_FACTORY[sizeVersion].border,
  borderRadius: "56px",
  backgroundColor: ui.white[700],
  textAlign: "right",
  paddingRight: SIZE_STYLE_FACTORY[sizeVersion].pillPaddingRight,
  width: SIZE_STYLE_FACTORY[sizeVersion].pillWidth,
  height: SIZE_STYLE_FACTORY[sizeVersion].pillHeight,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginTop: SIZE_STYLE_FACTORY[sizeVersion].wrapperMarginTop,

  span: {
    fontSize: SIZE_STYLE_FACTORY[sizeVersion].fontSize,
  },
});

const verticalPill = {
  border: `3px solid ${ui.neutral[100]}`,
  width: "100%",
  borderRadius: "56px",
  backgroundColor: ui.white[700],
  textAlign: "center",
  padding: "4px 24px",
  borderBottomWidth: "8px",

  span: {
    fontSize: "72px",
    lineHeight: "1",
  },
};

export const pill = (sizeVersion, direction) => ({
  border: SIZE_STYLE_FACTORY[sizeVersion].border,
  ...(sizeVersion === SIZE_TYPES.VIEW_PAGE_ACTIVITY_PICKER && {
    borderBottom: `4px solid ${ui.neutral[100]}`,
  }),
  ...(direction === "horizontal" ? horizontalPill(sizeVersion) : verticalPill),
});

const verticalIconWrapper = {
  width: "100%",
  display: "flex",
  marginBottom: "-15px",
};

export const iconWrapper = (sizeVersion, direction) => ({
  ...(direction === "horizontal"
    ? horizontalIconWrapper(sizeVersion)
    : verticalIconWrapper),
});

export const icon = {
  width: "100%",
  height: "auto",
};

export const total = (darkText) => ({
  ...heading3Obj,
  ...fontFamily.circular,
  fontWeight: 700,
  color: darkText ? "black" : "white",
});

export const loadingWrapper = {
  height: "24px",
  width: "24px",
  margin: 0,
};
